import Offcanvas from "react-bootstrap/Offcanvas";
import "bootstrap/dist/css/bootstrap.min.css";
import { RxCross2 } from "react-icons/rx";
import { Box, Typography } from "@mui/material";
import {
  convertArrayToString,
  customTextColor,
  formatDate,
  formatText,
  formatTime,
} from "../../../utils/const";
import styles from "../InternalTracker.module.css";
import { useNavigate } from "react-router-dom";

function SideDrawer({
  handleClose,
  show,
  row,
  candidateDetailsSubmisionList,
  getPreferLocationNames,
}) {
  const navigate = useNavigate();
  return (
    <Offcanvas
      show={show}
      onHide={handleClose}
      placement="end"
      scroll={false}
      backdrop={false}
      style={{
        border: "none",
        marginTop: "74px",
        width: "470px",
        padding: "0 0 0 10px",
        boxShadow: "-4px 0 10px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Offcanvas.Header
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Offcanvas.Title style={{ fontWeight: "600", color: customTextColor }}>
          Submission history of {row?.full_name}
        </Offcanvas.Title>
        <RxCross2
          style={{
            fontSize: "22px",
            cursor: "pointer",
            color: customTextColor,
          }}
          onClick={handleClose}
        />
      </Offcanvas.Header>
      <Offcanvas.Body>
        {/* <Box sx={{ color: customTextColor }} className={styles.canvas_body}>
          <span style={{ display: "flex", justifyContent: "space-between" }}>
            <span>
              <Typography
                sx={{ color: "#4287f5", fontSize: "40px !important" }}
              >
                <b>{row?.filled_percentage ? row?.filled_percentage : 0}</b>
              </Typography>
              <Typography>
                <b> Profile Completed </b>
              </Typography>
            </span>
            <span style={{ marginTop: "40px" }}>
              <Box className={styles.check_btns}>
                <button
                  onClick={() =>
                    navigate("/internal-tracker-add", { state: { row: row } })
                  }
                >
                  Check Now
                </button>
              </Box>
            </span>
          </span>
        </Box> */}
        {/* 
        <Box className={styles.submissions_body}>
          <span style={{ display: "flex", justifyContent: "space-between" }}>
            <span>
              <Typography sx={{ fontSize: "30px !important" }}>
                <b>{countData?.total_internal_submission}</b>
              </Typography>
              <Typography sx={{ fontSize: "16px !important" }}>
                Internal Submissions
              </Typography>
            </span>
            <span style={{ marginTop: "15px" }}>
              <Typography>
                <IoDesktopOutline
                  style={{
                    fontSize: "50px",
                    backgroundColor: "#bed7ed",
                    padding: "6px",
                    borderRadius: "3px",
                    color: "#4c68b0",
                  }}
                />
              </Typography>
            </span>
          </span>
        </Box>
        <Box
          className={styles.submissions_body}
          sx={{ margin: "14px 0 !important" }}
        >
          <span style={{ display: "flex", justifyContent: "space-between" }}>
            <span>
              <Typography sx={{ fontSize: "30px !important" }}>
                <b>{countData?.total_client_submission}</b>
              </Typography>
              <Typography sx={{ fontSize: "16px !important" }}>
                Client Submissions
              </Typography>
            </span>
            <span style={{ marginTop: "15px" }}>
              <Typography>
                <PiBuildingOffice
                  style={{
                    fontSize: "50px",
                    backgroundColor: "#bed7ed",
                    padding: "6px",
                    borderRadius: "3px",
                    color: "#4c68b0",
                  }}
                />
              </Typography>
            </span>
          </span>
        </Box>
        <Box
          className={styles.submissions_body}
          sx={{ margin: "14px 0 !important" }}
        >
          <span style={{ display: "flex", justifyContent: "space-between" }}>
            <span>
              <Typography sx={{ fontSize: "30px !important" }}>
                <b>{countData?.total_interview}</b>
              </Typography>
              <Typography sx={{ fontSize: "16px !important" }}>
                Interviews
              </Typography>
            </span>
            <span style={{ marginTop: "15px" }}>
              <Typography>
                <PiFileVideoFill
                  style={{
                    fontSize: "50px",
                    backgroundColor: "#bed7ed",
                    padding: "6px",
                    borderRadius: "3px",
                    color: "#4c68b0",
                  }}
                />
              </Typography>
            </span>
          </span>
        </Box>
        <Box
          className={styles.submissions_body}
          sx={{ margin: "14px 0 !important" }}
        >
          <span style={{ display: "flex", justifyContent: "space-between" }}>
            <span>
              <Typography sx={{ fontSize: "30px !important" }}>
                <b>{countData?.total_confirmed}</b>
              </Typography>
              <Typography sx={{ fontSize: "16px !important" }}>
                Offer Confirmations
              </Typography>
            </span>
            <span style={{ marginTop: "15px" }}>
              <Typography>
                <PiWheelchair
                  style={{
                    fontSize: "50px",
                    backgroundColor: "#bed7ed",
                    padding: "6px",
                    borderRadius: "3px",
                    color: "#4c68b0",
                  }}
                />
              </Typography>
            </span>
          </span>
        </Box> */}

        {candidateDetailsSubmisionList?.length > 0 ? (
          candidateDetailsSubmisionList?.map((result) => {
            return (
              <>
                <Box className={styles.submisionDetails}>
                  <Box>
                    <Typography>
                      <b>{result?.requirement?.job_title}</b>
                    </Typography>
                    <Typography>
                      {getPreferLocationNames(result?.requirement?.location)}
                    </Typography>
                    {/* <Typography>{getWorkAuthorization(result?.requirement?.location)}, ${result?.requirement?.rate}Hourly</Typography> */}
                    {/* <Typography>
                      Status:{" "}
                      {formatText(
                        result?.requirement?.submission?.progress[0]
                          ?.submission_status
                      )}
                    </Typography> */}
                    <Typography>
                      {convertArrayToString(
                        result?.requirement?.requirement_type
                      )}
                    </Typography>
                    <Typography>
                      Client: {result?.requirement?.client_name}
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "end",
                    }}
                  >
                    <Typography>
                      {" "}
                      <b>
                        {" "}
                        {formatText(
                          result?.requirement?.submission?.progress[0]
                            ?.submission_status
                        )}
                      </b>
                    </Typography>
                    <Typography>
                      {formatDate(result?.requirement?.created_at)},
                      {formatTime(result?.requirement?.created_at)}
                    </Typography>
                    <Typography
                      sx={{
                        marginTop: "15px",
                        textDecoration: "underline",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        navigate("/submision-tracker");

                        localStorage.setItem(
                          "internalSubmissionDetails",
                          JSON.stringify({
                            row: result?.requirement,
                            type: "view",
                          })
                        );
                      }}
                    >
                      view job
                    </Typography>
                  </Box>
                </Box>
                <hr />
              </>
            );
          })
        ) : (
          <h6 style={{ textAlign: "center", marginTop: "20px" }}>
            No Submission Found
          </h6>
        )}
      </Offcanvas.Body>
    </Offcanvas>
  );
}

export default SideDrawer;
